/**
 * "This wallet has reached the minimum its owner set": the balance is AT OR BELOW the minimum, and a minimum is set
 * (> 0; 0 means off). Both sides are compared in whole paise, so decimal dust (499.99999999999994 against 500) cannot
 * hide it. One rule for the Company Wallet cards and the user's Policy Wallet page, and the same rule the server
 * uses for the navbar bell (RayalBrokers-backend shared/walletAlerts.js), so the chip and the bell always agree.
 */
export const isAtOrBelowMinimum = (balance, minimum) => {
  const paise = (n) => Math.round((Number(n) || 0) * 100);
  return paise(minimum) > 0 && paise(balance) <= paise(minimum);
};
